import { useStore } from "..";
export const useUserOnboarding = () => useStore(({ userOnboarding }) => userOnboarding);
